// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/form","groupRoot":"form-m__groupRoot__xOvIb","column":"form-m__column__c4hQg","fieldRoot":"form-m__fieldRoot__fLBSE"};